import { FOLLOW_UPS_API_URL, FOLLOW_UPS_FILTER_URL } from 'constants/ApiConstants';
import * as types from 'modules/followUp/actionTypes';

/**
 * @param {Object} params
 * @param {Object} [meta={}]
 * @returns {import("../types/action").FetchFollowUpsAction}
 */
export const fetchFollowUps = (params, meta = {}) => ({
  type: types.FETCH_FOLLOW_UPS,
  payload: {
    request: {
      method: 'GET',
      url: FOLLOW_UPS_FILTER_URL,
      params: {
        sort: 'createdOn,desc',
        projection: 'page',
        page: 0,
        ...params,
      },
    },
  },
  meta: {
    '@app-request': true,
    ...meta,
  },
});

/**
 * @param {import("../types/action").FilterFollowUpFields} field
 * @param {import("../types/action").FilterFollowUpValue} value
 * @param {Object} [meta={}]
 * @returns {import("../types/action").SetFollowUpDashboardFilterAction}
 */
export const setFollowUpDashboardFilter = (field, value, meta = {}) => ({
  type: types.SET_FOLLOW_UP_DASHBOARD_FILTER,
  payload: { field, value },
  meta,
});

/**
 * @param {import("../types/action").FilterPayload[]} filters
 * @param {Object} [meta={}]
 * @returns {import("../types/action").SetFollowUpDashboardFiltersAction}
 */
export const setFollowUpDashboardFilters = (filters, meta = {}) => ({
  type: types.SET_FOLLOW_UP_DASHBOARD_FILTERS,
  payload: filters,
  meta,
});

/**
 * @param {import("../types/action").FilterFollowUpFields} field
 * @param {import("../types/action").FilterFollowUpValue} value
 * @param {Object} [meta={}]
 * @returns {import("../types/action").RemoveFollowUpDashboardFilterAction}
 */
export const removeFollowUpDashboardFilter = (field, value, meta = {}) => ({
  type: types.REMOVE_FOLLOW_UP_DASHBOARD_FILTER,
  payload: {
    field,
    value,
  },
  meta,
});

/**
 * @param {unknown} payload
 * @param {Object} [meta={}]
 * @returns {import("../types/action").ClearFollowUpDashboardFiltersAction}
 */
export const clearFollowUpDashboardFilters = (payload, meta = {}) => ({
  type: types.CLEAR_FOLLOW_UP_DASHBOARD_FILTER,
  payload,
  meta,
});

/**
 * @param {string} followUpId
 * @param {Object} [meta={}]
 * @returns {import("../types/action").SendFollowUpAction}
 */
export const sendFollowUp = (followUpId, meta = {}) => ({
  type: types.SEND_FOLLOW_UP,
  payload: {
    request: {
      method: 'POST',
      url: `${FOLLOW_UPS_API_URL}/${followUpId}/send`,
    },
  },
  meta
});

/**
 * @param {string} followUpId
 * @param {string} sendDate
 * @param {Object} [meta={}]
 * @returns {import("../types/action").ScheduleFollowUpAction}
 */
export const scheduleFollowUp = (followUpId, sendDate, meta = {}) => ({
  type: types.SCHEDULE_FOLLOW_UP,
  payload: {
    request: {
      method: 'POST',
      url: `${FOLLOW_UPS_API_URL}/${followUpId}/schedule`,
      data: { sendDate },
    },
  },
  meta
});

/**
 * @param {string} followUpId
 * @param {Object} [meta={}]
 * @returns {import("../types/action").UnscheduleFollowUpAction}
 */
export const unscheduleFollowUp = (followUpId, meta = {}) => ({
  type: types.UNSCHEDULE_FOLLOW_UP,
  payload: {
    request: {
      method: 'POST',
      url: `${FOLLOW_UPS_API_URL}/${followUpId}/unschedule`,
    },
  },
  meta
});
